export class SysFeatures {
  static readonly ClientFillNoSTPHighlight: string = "system.features.ClientFillNoSTPHighlight";
  static readonly RiskFillNoSTPHighlight: string = "system.features.RiskFillNoSTPHighlight";
  static readonly algosEnabled: string = "system.features.algosEnabled";
  static readonly benchmarkModificationEnable: string =
    "system.features.benchmarkModificationEnable";
  static readonly benchmarksEnabled: string = "system.features.benchmarksEnabled";
  static readonly benchmarkLargePositionMonitoringEnabled: string =
    "system.features.benchmarkLargePositionMonitoringEnabled";
  static readonly bmEntryTraderGroupEnabled: string = "system.features.bmEntryTraderGroupEnabled";
  static readonly bmRiskRoutingEnabled: string = "system.features.bmRiskRoutingEnabled";
  static readonly bmFixingDateEnabled: string = "system.features.bmFixingDateEnabled";
  static readonly bmStpAmountEnabled: string = "system.features.bmStpAmountEnabled";
  static readonly ccEnabled: string = "system.features.ccEnabled";
  static readonly clientTraderUsersEnabled: string = "system.features.clientTraderUsersEnabled";
  static readonly displayUserNames: string = "system.features.displayUserNames";
  static readonly cancelWarningThreshold: string = "system.features.cancelWarningThreshold";
  static readonly fillWarningThreshold: string = "system.features.fillWarningThreshold";
  static readonly enableCallBidAsk: string = "system.features.enableCallBidAsk";
  static readonly enableHoldSTPCheckbox: string = "system.features.enableHoldSTPCheckbox";
  static readonly enableSLPartFill: string = "system.features.enableSLPartFill";
  static readonly fwdEnabled: string = "system.features.fwdEnabled";
  static readonly gammaStrategiesEnabled: string = "system.features.gammaStrategiesEnabled";
  static readonly independentEntryComments: string = "system.features.independentEntryComments";
  static readonly ladderAggregation: string = "system.features.ladderAggregation";
  static readonly ladderPositionEnabled: string = "system.features.ladderPositionEnabled";
  static readonly mandatoryCancelCommentsEnabled: string =
    "system.features.mandatoryCancelCommentsEnabled";
  static readonly markupEnabled: string = "system.features.markupEnabled";
  static readonly markupRejectEnabledFg: string = "system.features.markupRejectEnabledFg";
  static readonly markupRetrievalEnabled: string = "system.features.markupRetrievalEnabled";
  static readonly markupRetrievalTypeLimit: string = "markup.ordertype.LIMIT";
  static readonly markupRetrievalTypeAlgo: string = "markup.ordertype.ALGO";
  static readonly markupRetrievalTypeBmark: string = "markup.ordertype.BMARK";
  static readonly markupBenchmarkCheckboxSelected: string =
    "system.features.markupBenchmarkCheckboxSelected";
  static readonly markupLimitCbx: string = "system.features.markupLimitCheckboxSelected";
  static readonly markupAlgoCbx: string = "system.features.markupAlgoCheckboxSelected";
  static readonly markupBmarkCbx: string = "system.features.markupBenchmarkCheckboxSelected";
  static readonly markupAlgoEntryEnabled: string = "system.features.algoEntryMarkupEnabled";
  static readonly multiOrderEnabled: string = "system.features.multiOrderEnabled";
  static readonly ndfEnabled: string = "system.features.ndfEnabled";
  static readonly ndfSpotTriggerEnabled: string = "ALLOW_NDF_SPOT_TRIGGER_LIMIT";
  static readonly ndfFwdTriggerEnabled: string = "ALLOW_NDF_FWD_TRIGGER_LIMIT";
  static readonly offshoreEnabled: string = "system.features.offshoreEnabled";
  static readonly on_partial_branches_enabled: string =
    "system.features.on_partial_branches_enabled";
  static readonly opsInterventionAltResubmitEnabled: string =
    "system.features.opsInterventionAltResubmitEnabled";
  static readonly orderSuspensionEnabled: string = "system.features.orderSuspensionEnabled";
  static readonly partFillDisabledTypeText: string = "system.features.partFillDisabledTypeText";
  static readonly pcOptionEnabled: string = "system.features.pcOptionEnabled";
  static readonly privateOrdersEnabled: string = "system.features.privateOrdersEnabled";
  static readonly privatiseClientComments: string = "system.features.privatiseClientComments";
  static readonly privatisePrivateComments: string = "system.features.privatisePrivateComments";
  static readonly restrictClientComments: string = "system.features.restrictClientComments";
  static readonly slAskEnabled: string = "system.features.slAskEnabled";
  static readonly slAtRateEnabled: string = "system.features.slAtRateEnabled";
  static readonly slBidEnabled: string = "system.features.slBidEnabled";
  static readonly slQuickFillEnabled: string = "system.features.slQuickFillEnabled";
  static readonly spotEnabled: string = "system.features.spotEnabled";
  static readonly sspEnabled: string = "system.features.sspEnabled";
  static readonly swpEnabled: string = "system.features.swpEnabled";
  static readonly tSlAskEnabled: string = "system.features.tSlAskEnabled";
  static readonly tSlAtRateEnabled: string = "system.features.tSlAtRateEnabled";
  static readonly tSlBidEnabled: string = "system.features.tSlBidEnabled";
  static readonly trailingStopsEnabled: string = "system.features.trailingStopsEnabled";
  static readonly vehicleCcyFillingEnabled: string = "system.features.vehicleCcyFillingEnabled";
  static readonly featuresEnablePrivateComments: string = "system.features.enablePrivateComments";
  static readonly helpPass: string = "system.helpPass";
  static readonly helpURL: string = "system.helpURL";
  static readonly helpUser: string = "system.helpUser";
  static readonly helpValidatorURL: string = "system.helpValidatorURL";
  static readonly killTimerSeconds: string = "system.killTimerSeconds";
  static readonly marketRateSourceID: string = "system.marketRateSourceID";
  static readonly maximumGammaRungs: string = "system.maximumGammaRungs";
  static readonly pauseRatesTimeOutSecs: string = "system.pauseRatesTimeOutSecs";
  static readonly rfqEnabled: string = "platform.rfqEnabled";
  static readonly streamingPingTimeout: string = "system.streamingPingTimeout";
  static readonly autoFillEnabled: string = "AUTO_FILL_ENABLED_FG";
  static readonly searchDelay: string = "system.searchDelay";
  static readonly hotNotifCoolDownSecs: string = "system.features.hotNotifCoolDownSecs";
  static readonly marketOrdersEnabled: string = "system.features.marketOrdersEnabled";
  static readonly blotterMarketBar: string = "system.features.blotterMarketBar";
  static readonly refreshTokenInterval: string = "system.refreshTokenInterval";
  static readonly detailFillBatchCount: string = "system.html.detailFillBatchCount";
  static readonly cancelBatchCount: string = "system.html.cancelBatchCount";
  static readonly cancelBurstCount: string = "system.html.cancelBurstCount";
  static readonly acceptBatchCount: string = "system.html.acceptBatchCount";
  static readonly maxBlotters: string = "system.maxLadders";
  static readonly maxClientTradeBlotters: string = "system.maxClientTradeBlotters";
  static readonly maxRiskTradeBlotters: string = "system.maxRiskTradeBlotters";
  static readonly fixingsRecentPurgeInterval: string = "fixings.recentPurgeIntervalSecs"; // add to db
  static readonly fixingsRecentOrdersIdleOffset: string = "fixings.maxRecentFixingIdleSecs"; // add to db
  static readonly fixingsRecentPurgeOffset: string = "BMARK_RECENT_FIXING_SINCE_HRS_OFFSET";
  static readonly forwardPricingType: string = "system.forward.pricing.type";

  static readonly fixingOrderShortName: string = "FIXING_ORDER_SHORT_NM";
  static readonly fixingOrderLongName: string = "FIXING_ORDER_LONG_NM";
  static readonly manualRiskRouting: string = "system.features.enableManualRiskRouting";
  static readonly bmAutoHedging: string = "system.features.bmAutoHedgingEnabled";
  static readonly allowZeroHardCutOff: string = "system.features.allowZeroHardCutOff";
  static readonly maxBenchmarkOffset: string = "system.features.maxBenchmarkOffset";
  static readonly maxBenchmarkSweepOffset: string = "system.features.maxBenchmarkSweepOffset";

  static readonly passThroughColumEnabled: string =
    "system.features.enablePassThroughParametersColumnUI";

  static readonly asynchOpsChunks: string = "system.asynch.ops.chunks";

  static readonly connectionMonitorClearHours: string = "CONNECTION_MONITOR_CLEAR_HOURS";
  static readonly maxProfileChangeTimeout: string = "system.logout.maxProfileChangeTimeout";

  static readonly manualExecutionCallName: string = "CALL_MANUAL_EXEC_NM";

  static readonly logObfuscation: string = "logging.obfuscate";

  static readonly enableCreditAtEntry: string = "system.EnableCreditAtEntry";
  static readonly limitEnableCreditAtFill: string = "system.limitEnableCreditAtFill";
  static readonly limitEnableCreditDaily: string = "system.limitEnableCreditDaily";
  static readonly limitEnableCreditProximity: string = "system.limitEnableCreditProximity";

  static readonly volPerMinUIRefreshMS: string = "system.volPerMinUIRefreshMS";

  static readonly triggerTPThroughSpread: string = "TRIGGER_TP_THROUGH_SPREAD";
  static readonly allowSptBm: string = "ALLOW_SPT_BM";
  static readonly allowFwdBm: string = "ALLOW_FWD_BM";
  static readonly allowSptLimit: string = "ALLOW_SPT_LIMIT";
  static readonly allowFwdSpotTriggerLimit: string = "ALLOW_FWD_SPOT_TRIGGER_LIMIT";
  static readonly allowFwdFwdTriggerLimit: string = "ALLOW_FWD_FWD_TRIGGER_LIMIT";
  static readonly allowNdfSpotTriggerLimit: string = "ALLOW_NDF_SPOT_TRIGGER_LIMIT";
  static readonly allowNdfFwdTriggerLimit: string = "ALLOW_NDF_FWD_TRIGGER_LIMIT";

  static readonly systemBranchCd: string = "SYSTEM_BRANCH_CD";
  static readonly defaultTraderGroupId: string = "DEFAULT_TRADER_GROUP_ID";

  static readonly equivalence_ccy_cd: string = "EQUIVALENCE_CCY_CD";
  static readonly default_system_equiv_ccy: string = "DEFAULT_SYSTEM_EQUIV_CCY";
  static readonly auto_sl_slippage: string = "system.AutoSLSlippage";

  static readonly idNumericLength = "system.IDNumericLength";
  static readonly orderIDPrefix = "system.OrderIDPrefix";
  static readonly strategyIDPrefix = "system.StrategyIDPrefix";
  static readonly tradeIDPrefix = "system.TradeIDPrefix";
  static readonly allocationIDPrefix = "system.AllocationIDPrefix";

  static readonly maxQueryResult = "system.maxQueryResult";

  static readonly fwdPricingModeBmark: string = "fwdpricing.ordertype.BMARK";
  static readonly fwdPricingModeALGO: string = "fwdpricing.ordertype.ALGO";

  static readonly systemTDRTime = "DEFAULT_TRADE_DATE_ROLL_OVER_TIME";
  static readonly systemTDRZone = "DEFAULT_TRADE_DATE_ROLL_OVER_TZ";

  static readonly orderDetailsReloadInterval = "system.features.OrderDetailsReloadInterval";

  static readonly bmNPV = "system.features.bmNPV";

  /** When 'Y', restricts entry of NDF orders to 1M only - value date will be disabled */
  static readonly ndf1MOnly = "system.features.limits1MNDFOnly";
}
